import { useEffect, useState } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface OfflineOverlayProps {
  isOnline: boolean;
}

export const OfflineOverlay: React.FC<OfflineOverlayProps> = ({ isOnline }) => {
  const [show, setShow] = useState(!isOnline);
  const [isVisible, setIsVisible] = useState(!isOnline);

  useEffect(() => {
    if (!isOnline) {
      setShow(true);
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
      const timer = setTimeout(() => setShow(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOnline]);

  if (!show) {
    return null;
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      
      <div className="relative z-10 w-full max-w-md px-4">
        <Alert className="border-2 border-destructive shadow-2xl bg-background">
          <div className="flex flex-col items-center text-center gap-4 py-4">
            <div className="rounded-full bg-destructive/10 p-4">
              <WifiOff className="h-12 w-12 text-destructive" />
            </div>
            
            <div>
              <AlertTitle className="text-xl font-bold mb-2">
                No Internet Connection
              </AlertTitle>
              <AlertDescription className="text-muted-foreground">
                Please check your WiFi or mobile data connection and try again.
              </AlertDescription>
            </div>

            <div className="flex flex-col gap-2 w-full">
              <Button
                onClick={handleRefresh}
                variant="default"
                className="w-full"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Retry Connection
              </Button>
              
              <p className="text-xs text-muted-foreground mt-2">
                Waiting for connection to be restored...
              </p>
            </div>
          </div>
        </Alert>
      </div>
    </div>
  );
};
